import memoize from "memoize-one";
import * as _ from "lodash";

export const filterGanhoPesoMemoize = memoize((list, textoFiltrar) =>
  _.filter(list, (ganhoPeso) => {
    ganhoPeso.Nome = ganhoPeso.Nome || "";
    return ganhoPeso.Nome.toUpperCase().includes(textoFiltrar.toUpperCase());
  })
);

export const MESES_ANO = [
  { Nome: "Janeiro", Id: "janeiro", Label: "Jan" },
  { Nome: "Fevereiro", Id: "fevereiro", Label: "Fev" },
  { Nome: "Marco", Id: "março", Label: "Mar" },
  { Nome: "Abril", Id: "abril", Label: "Abr" },
  { Nome: "Maio", Id: "maio", Label: "Maio" },
  { Nome: "Junho", Id: "junho", Label: "Jun" },
  { Nome: "Julho", Id: "julho", Label: "Jul" },
  { Nome: "Agosto", Id: "agosto", Label: "Ago" },
  { Nome: "Setembro", Id: "setembro", Label: "Set" },
  { Nome: "Outubro", Id: "outubro", Label: "Out" },
  { Nome: "Novembro", Id: "novembro", Label: "Nov" },
  { Nome: "Dezembro", Id: "dezembro", Label: "Dez" },
];

export const mesesNull = {
  Janeiro: null,
  Fevereiro: null,
  Marco: null,
  Abril: null,
  Maio: null,
  Junho: null,
  Julho: null,
  Agosto: null,
  Setembro: null,
  Outubro: null,
  Novembro: null,
  Dezembro: null,
};

export const mensagemBotao = {
  mesesNaoPreenchidos:
    "Por favor, preencha todos os campos para salvar a curva.",
  mesValorDiferenteZero: "Ao menos um mês deve conter valor diferente de zero.",
  mesesValorMaiorQueValor:
    "O valor de ganho médio diário não pode ser maior que 5 Kg por dia.",
};

export const translateWeightGainCurveToPortuguese = (weightGainCurve) => {
  if (!weightGainCurve) return null;
  return {
    IdCurvaGanhoPeso: weightGainCurve.id,
    Nome: weightGainCurve.name,
    IdFazenda: weightGainCurve.farmId,
    Janeiro: weightGainCurve.january,
    Fevereiro: weightGainCurve.february,
    Marco: weightGainCurve.march,
    Abril: weightGainCurve.april,
    Maio: weightGainCurve.may,
    Junho: weightGainCurve.june,
    Julho: weightGainCurve.july,
    Agosto: weightGainCurve.august,
    Setembro: weightGainCurve.september,
    Outubro: weightGainCurve.october,
    Novembro: weightGainCurve.november,
    Dezembro: weightGainCurve.december,
    UsuarioCriacao: weightGainCurve.creationUser,
    UsuarioAlteracao: weightGainCurve.updateUser,
    UsuarioExclusao: weightGainCurve.deletionUser,
    DataCriacao: weightGainCurve.createdAt,
    DataAlteracao: weightGainCurve.updatedAt,
    DataExclusao: weightGainCurve.deletedAt,
    Excluido: weightGainCurve.deletedAt ? true : false,
  };
};

/**
 * Converts a CurvaGanhoPeso object to a WeightGainCurve object.
 * @param {CurvaGanhoPeso} curvaGanhoPeso - The CurvaGanhoPeso object to convert.
 * @returns {WeightGainCurve} The converted WeightGainCurve object.
 */
export const toWeightGainCurve = (curvaGanhoPeso) => {
  if (!curvaGanhoPeso) return null;
  return {
    id: curvaGanhoPeso.IdCurvaGanhoPeso,
    name: curvaGanhoPeso.Nome,
    farmId: curvaGanhoPeso.IdFazenda,
    january: curvaGanhoPeso.Janeiro,
    february: curvaGanhoPeso.Fevereiro,
    march: curvaGanhoPeso.Marco,
    april: curvaGanhoPeso.Abril,
    may: curvaGanhoPeso.Maio,
    june: curvaGanhoPeso.Junho,
    july: curvaGanhoPeso.Julho,
    august: curvaGanhoPeso.Agosto,
    september: curvaGanhoPeso.Setembro,
    october: curvaGanhoPeso.Outubro,
    november: curvaGanhoPeso.Novembro,
    december: curvaGanhoPeso.Dezembro,
    creationUser: curvaGanhoPeso.UsuarioCriacao,
    updateUser: curvaGanhoPeso.UsuarioAlteracao,
    deletionUser: curvaGanhoPeso.UsuarioExclusao,
    createdAt: curvaGanhoPeso.DataCriacao,
    updatedAt: curvaGanhoPeso.DataAlteracao,
    deletedAt: curvaGanhoPeso.DataExclusao,
  };
};

/**
 * Mapeamento de nomes de meses em diferentes idiomas (português e espanhol)
 * para o nome do mês padronizado em português.
 *
 * Esse objeto é útil para normalizar dados de entrada que possam vir em
 * idiomas diferentes, garantindo consistência nos nomes dos meses.
 *
 * @constant
 * @type {Object.<string, string>}
 * @example
 * // Retorna "Janeiro"
 * MESES_MAP["Enero"];
 *
 * // Retorna "Outubro"
 * MESES_MAP["Octubre"];
 */
export const MESES_MAP = {
  Janeiro: "Janeiro",
  Enero: "Janeiro",
  Fevereiro: "Fevereiro",
  Febrero: "Fevereiro",
  Marco: "Marco",
  Março: "Marco",
  Marzo: "Marco",
  Abril: "Abril",
  Maio: "Maio",
  Mayo: "Maio",
  Junho: "Junho",
  Junio: "Junho",
  Julho: "Julho",
  Julio: "Julho",
  Agosto: "Agosto",
  Setembro: "Setembro",
  Septiembre: "Setembro",
  Octubre: "Outubro",
  Outubro: "Outubro",
  Novembro: "Novembro",
  Noviembre: "Novembro",
  Dezembro: "Dezembro",
  Diciembre: "Dezembro",
};
